// English translations for the customer checkout step (French string -> English).
// Clients always read the French; these lines are for an admin who opens the
// flow with the panel set to English.
const m: Record<string, string> = {
  // ── Cash-on-delivery option — the advance first (owner, 2026-09-29, « 1a ») ──
  'Avance + paiement à la livraison 📦': 'Advance + pay on delivery 📦',
  'Une petite avance de {advance} MAD par virement pour lancer l’impression, puis {rest} MAD en espèces à la réception de votre album.':
    'A small advance of {advance} MAD by bank transfer to start printing, then {rest} MAD in cash when your album arrives.',
  'Une petite avance par virement pour lancer l’impression, puis le reste en espèces à la réception de votre album.':
    'A small advance by bank transfer to start printing, then the rest in cash when your album arrives.',
  'Une petite avance de {advance} MAD par virement pour lancer l’impression.':
    'A small advance of {advance} MAD by bank transfer to start printing.',
};
export default m;
